var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThron(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6832 14.8991V14.8972C15.5789 14.9048 15.0415 14.937 13.8423 14.937C12.8849 14.937 12.211 14.9086 11.974 14.8972V14.9001C8.28849 14.738 5.53764 14.0962 5.53764 13.3284C5.53764 12.5616 8.28849 11.9198 11.974 11.7549V14.2612C12.2148 14.2782 12.9048 14.319 13.8585 14.319C15.0026 14.319 15.5761 14.2716 15.6832 14.2621V11.7568C19.3611 11.9208 22.1053 12.5625 22.1053 13.3284C22.1053 14.0962 19.3611 14.7361 15.6832 14.8991ZM15.6832 11.4961V9.25334H20.8152V5.83325H6.84197V9.25334H11.974V11.4952C7.80316 11.6866 4.6665 12.5132 4.6665 13.5028C4.6665 14.4925 7.80316 15.3181 11.974 15.5105V22.6976H15.6832V15.5086C19.8474 15.3172 22.9765 14.4915 22.9765 13.5028C22.9765 12.5142 19.8474 11.6885 15.6832 11.4961Z",
    fill: "#ABABAB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThron);
export default __webpack_public_path__ + "static/media/thron.eead758d863e0d2360e9a964cb825cdb.svg";
export { ForwardRef as ReactComponent };